const aboutUs = {
    title: 'About Us',
    subtitle: 'Discover the passion and experience that make "La Dolce Vita" the perfect choice for your adventures in Abruzzo',
    breadcrumb: 'About Us',
    ourStory: {
        title: 'Our Story',
        paragraph1: 'We are two friends born and raised in Abruzzo, deeply connected to our land. After years of traveling and discovery, we decided to create an agency with one goal: to introduce the most authentic Abruzzo to those seeking a true, immersive, and stress-free experience.',
        paragraph2: '',
        paragraph3: ''
    },
    whatWeOrganize: {
        title: 'What We Organize',
        groupTravel: 'Customized group travel',
        authenticExperiences: 'Authentic experiences: traditional cuisine, trekking, villages, nature, crafts',
        wineTours: 'Food and wine tours with local producers',
        customActivities: 'Tailored activities: for families, couples, groups, companies, or schools',
        completeServices: 'Guide services, transportation, and complete assistance throughout the territory'
    },
    mission: {
        title: 'Our Mission',
        subtitle: 'Our agency was born with a clear goal: to help you experience Abruzzo in a simple, authentic, and worry-free way.\nWe know every corner of this land—from the hidden trails of Gran Sasso to the secret beaches of the Costa dei Trabocchi, from small wine producers to village festivals that few tourists manage to find.',
        description: ''
    },
    values: {
        sustainability: {
            title: 'Sustainability',
            description: 'We promote responsible tourism that respects the environment and supports local communities.'
        },
        authenticity: {
            title: 'Authenticity',
            description: 'We offer genuine experiences that allow you to discover the true spirit of Abruzzo.'
        },
        excellence: {
            title: 'Excellence',
            description: 'We are committed to providing superior quality services and an impeccable customer experience.'
        }
    },
    whyChooseUs: {
        title: 'Why Choose Us',
        subtitle: 'Because Abruzzo cannot be improvised. It is not a region to visit with a watch in hand and an itinerary copied from the internet. It is a land that must be listened to, traversed, felt. And to do it the right way, you need someone who truly knows it.\nWith us, you won\'t be just a tourist, but a privileged guest, accompanied by people who deeply love this region and have chosen to share its beauty with those who can appreciate it',
        localExperience: {
            title: 'Local Experience',
            description: 'We know every hidden corner and every tradition of Abruzzo, because we grew up here.'
        },
        worryFreeTravel: {
            title: 'Worry-Free Travel',
            description: 'We take care of everything: transport, hotels, restaurants, activities. You just enjoy the vacation.'
        },
        responsibleTourism: {
            title: 'Responsible Tourism',
            description: 'We collaborate with local realities and promote tourism that respects the environment and values communities.'
        }
    },
    customerService: {
        title: 'Exceptional Customer Service',
        subtitle: 'We are here for you, always',
        description: 'Our dedicated customer support team is available to help you with any questions, concerns, or special requests. We believe that exceptional service is the foundation of unforgettable travel experiences.',
        responseTime: 'We generally respond within a few hours during business hours',
        contactUs: 'Contact Us Now',
        supportTitle: 'Customer Support',
        veryFastAnswer: 'Very fast response',
        personalizedAssistance: 'Personalized assistance for every request',
        followUp: 'Follow-up until complete satisfaction'
    },
    cta: {
        title: 'Ready for Your Adventure?',
        subtitle: 'Join us and discover the magic of Abruzzo through authentic and unforgettable experiences.',
        discoverTrips: 'Discover Our Trips',
        exploreActivities: 'Explore Activities',
        exploreDestinations: 'Explore Destinations',
        exploreCuriosities: 'Explore Curiosities'
    }
};

export default aboutUs;
